import React from 'react'
import LocaleContext from '../context/LocaleContext';

export default function LocaleContextComponent({ children }) {
  const [locale, setLocale] = React.useState('en')

  return (
    <LocaleContext.Provider value={{
      locale: locale,
      setLocale: setLocale,
    }}>
      {children}
    </LocaleContext.Provider>
  )
}